module.exports = __webpack_public_path__ + "static/media/22904988_1638426186232566_2553101601466582828_o-thumb.bcf1c4ae.jpg";